import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    borderRadius: theme.shape.borderRadius * 2.5,
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(0.4),
    width: '100%'
  },
  preview: {
    display: 'block',
    height: '25px',
    width: '100%'
  }
}));

export const ColorPreview = ({ colors }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {colors.map((color, key) => <span key={key} className={classes.preview} style={{ backgroundColor: color }} />)}
    </div>
  );
};

ColorPreview.propTypes = {
  color: PropTypes.string
};

export default React.memo(ColorPreview);
